import lodash from 'lodash'

import i18n from '@/utils/i18n'
import { parseStatusText } from '@/api/tenders/request'
import { showQueryIndicator } from '@/api/tenders/util'
import { tenderStatus } from '@/utils/locale'

export function formatReviewTender (record) {
  const shownAttrs = {}
  shownAttrs.id = record.general.id
  shownAttrs.prNumber = (record.purchaseRequisition || {}).number || i18n.t('emptyValue')
  shownAttrs.prDescription = record.general.prDescription || i18n.t('emptyValue')
  shownAttrs.status = record.general.status || i18n.t('emptyValue')
  shownAttrs.site = record.general.site || i18n.t('emptyValue')
  shownAttrs.showQIndicator = showQueryIndicator(record)
  shownAttrs.statusText = parseStatusText(record.general)
  if (shownAttrs.status === tenderStatus.REJECTED) {
    shownAttrs.rejectReason = getLatestRejectReason(record.histories)
  }
  const lastQueryModifiedDate = getLastModifiedQueryUpdateDate(record.bids)
  if (lastQueryModifiedDate) {
    const tenderModifiedDate = record.general.updatedAt || record.general.createdAt
    shownAttrs.updateDate = lastQueryModifiedDate > tenderModifiedDate ? lastQueryModifiedDate : tenderModifiedDate
  } else {
    shownAttrs.updateDate = record.general.updatedAt || record.general.createdAt
  }

  shownAttrs.closingDate = record.general.closingDate
  shownAttrs.rawClosingDate = record.general.closingDate

  shownAttrs.budget = lodash.get(record, 'purchaseRequisition.budget', 0)
  shownAttrs.currencyCode = lodash.get(record, 'purchaseRequisition.currencyCode', '')
  shownAttrs.tenderType = record.general.tenderType
  shownAttrs.version = record.general.version
  shownAttrs.managedBy = record.general.managedBy
  shownAttrs.approvedBy = record.general.approvedBy
  shownAttrs.hasAccess = record.hasAccess
  shownAttrs.isRepresentative = record.isRepresentative
  return shownAttrs
}

export function formatConditionsOfContracts (type, isOldTerm, i18nPath) {
  const pathEnd = lodash.toLower(type)
  const cocValue = i18n.te(i18nPath) && i18n.t(i18nPath).length > 0 ? i18n.t(i18nPath)[0][pathEnd] : null
  if (Array.isArray(cocValue)) {
    return cocValue
      .filter(item => !isOldTerm || !item.oldTermExclude)
      .map(item => {
        const level = (parseInt(item.level) || 1) - 1
        return `<div style="padding-left:${level}rem;margin-bottom:10px;">${item.content}</div>`
      }).join('')
  }
  return cocValue || ''
}

function getLatestRejectReason (tenderHistory) {
  if (tenderHistory && tenderHistory.length > 0) {
    const rejectRecords = tenderHistory.filter(record =>
      record.status.indexOf(tenderStatus.REJECTED) >= 0)
      .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
    if (rejectRecords[0] && rejectRecords[0].detail) {
      return `${i18n.t('dashboard.rejectReason')}: ${rejectRecords[0].detail.rejectReason}`
    }
  }
  return ''
}

function getLastModifiedQueryUpdateDate (bids) {
  const lastModifiedDates = []
  bids.forEach(item => {
    if (item.queries.length > 0) {
      lastModifiedDates.push(getLastQueryModifiedDate(item.queries))
    }
  })
  if (lastModifiedDates.length > 0) {
    lodash.sortBy(lastModifiedDates)
    return lastModifiedDates[lastModifiedDates.length - 1]
  }
}

function getLastQueryModifiedDate (queries = []) {
  const lastQuery = queries.reduce((last, query) => {
    return last && new Date(last.createdAt).getTime() > new Date(query.createdAt).getTime() ? last : query
  }, {})
  return lastQuery.updatedAt || lastQuery.createdAt
}
